import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskPanelDirective } from './task-panel.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [TaskPanelDirective],
  exports: [TaskPanelDirective]
})
export class TaskPanelModule {
}
